import { marked } from 'marked';

import gettingStarted from '../../../docs/user-guide/getting-started.md?raw';
import overview from '../../../docs/user-guide/dashboard.md?raw';
import invoices from '../../../docs/user-guide/invoices.md?raw';
import quotations from '../../../docs/user-guide/quotations.md?raw';
import salesOrders from '../../../docs/user-guide/sales-orders.md?raw';
import deliveryNotes from '../../../docs/user-guide/delivery-notes.md?raw';
import creditNotes from '../../../docs/user-guide/credit-notes.md?raw';
import salesReturns from '../../../docs/user-guide/sales-returns.md?raw';
import purchaseOrders from '../../../docs/user-guide/purchase-orders.md?raw';
import products from '../../../docs/user-guide/products.md?raw';
import customers from '../../../docs/user-guide/customers.md?raw';
import suppliers from '../../../docs/user-guide/suppliers.md?raw';
import payments from '../../../docs/user-guide/payments.md?raw';
import businessProfile from '../../../docs/user-guide/business-profile.md?raw';
import backupRestore from '../../../docs/user-guide/backup-restore.md?raw';
import syncCloud from '../../../docs/user-guide/sync-cloud.md?raw';

interface HelpContentMap {
  gettingStarted: string;
  overview: string;
  invoices: string;
  quotations: string;
  'sales-orders': string;
  'delivery-notes': string;
  'credit-notes': string;
  'sales-returns': string;
  'purchase-orders': string;
  products: string;
  customers: string;
  suppliers: string;
  payments: string;
  'business-profile': string;
  'backup-restore': string;
  'sync-cloud': string;
}

const HELP_CONTENT: HelpContentMap = {
  gettingStarted,
  overview,
  invoices,
  quotations,
  'sales-orders': salesOrders,
  'delivery-notes': deliveryNotes,
  'credit-notes': creditNotes,
  'sales-returns': salesReturns,
  'purchase-orders': purchaseOrders,
  products,
  customers,
  suppliers,
  payments,
  'business-profile': businessProfile,
  'backup-restore': backupRestore,
  'sync-cloud': syncCloud,
};

const ROUTE_TO_HELP: Record<string, keyof typeof HELP_CONTENT> = {
  '#/dashboard': 'overview',
  '#/sales/quotations': 'quotations',
  '#/sales/orders': 'sales-orders',
  '#/sales/deliveries': 'delivery-notes',
  '#/sales/invoices': 'invoices',
  '#/sales/credit-notes': 'credit-notes',
  '#/sales/returns': 'sales-returns',
  '#/purchases/orders': 'purchase-orders',
  '#/inventory/products': 'products',
  '#/contacts/customers': 'customers',
  '#/contacts/suppliers': 'suppliers',
  '#/payments/receipts': 'payments',
  '#/settings/business': 'business-profile',
  '#/settings/backup': 'backup-restore',
  '#/settings/sync': 'sync-cloud',
};

export function getHelpFileForRoute(route: string): string {
  if (ROUTE_TO_HELP[route]) return ROUTE_TO_HELP[route];
  for (const [prefix, file] of Object.entries(ROUTE_TO_HELP)) {
    if (route === prefix || route.startsWith(prefix + '/')) return file;
  }
  return 'gettingStarted';
}

export function renderHelpHtml(key: keyof HelpContentMap): string {
  const source = HELP_CONTENT[key];
  if (!source) return '<p class="text-slate-400">Help content unavailable.</p>';
  return marked.parse(source, { async: false }) as string;
}

export function loadHelpHtml(route: string): string {
  return renderHelpHtml(getHelpFileForRoute(route) as keyof HelpContentMap);
}

export { HELP_CONTENT };
